import { PropsWithChildren, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getOrion } from '@orionprotocol/common';

import { useEnv } from '../../shared/hooks';
import { getAppChainId, getIsCustomConfig } from '../../shared/redux/selectors';
import { LumiaContext } from '../../shared/context';

export function LumiaProvider({ children }: PropsWithChildren): JSX.Element {
  const isCustomConfig = useSelector(getIsCustomConfig);

  const { env, envs } = useEnv();

  const lumia = useMemo(
    () => (isCustomConfig !== undefined ? getOrion(envs, env) : undefined),
    [env, envs, isCustomConfig],
  );

  const availableUnits = useMemo(() => (lumia ? lumia.units : {}), [lumia]);

  const appChainId = useSelector(getAppChainId);

  const activeUnit = useMemo(
    () => availableUnits?.[appChainId],
    [availableUnits, appChainId],
  ); 

  const memoedValue = useMemo(
    () => ({
      availableUnits,
      activeUnit,
      lumia,
    }),
    [availableUnits, activeUnit, lumia],
  );
  return (
    <LumiaContext.Provider value={memoedValue}>
      {children}
    </LumiaContext.Provider>
  );
}
